import { Box, Container, Typography } from "@mui/material";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import { motion } from "framer-motion";

import Banner from "../../assets/img/antilllen.png"; // Cambia por tu imagen

export const HeroHorarios = () => {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        background: "#fff",
        pt: {
          xs: 8,
          md: 12,
        },
        pb: {
          xs: 10,
          md: 14,
        },
      }}
    >
      {/* Imagen de fondo */}

      <Box
        component={motion.div}
        initial={{ scale: 1.08 }}
        animate={{ scale: 1 }}
        transition={{
          duration: 8,
          ease: "easeOut",
        }}
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          width: {
            xs: "100%",
            md: "58%",
          },

          backgroundImage: `url(${Banner})`,
          backgroundPosition: "center",
          backgroundSize: "cover",

          opacity: 0.22,

          filter:
            "grayscale(.15) brightness(1.15)",

          zIndex: 1,
        }}
      />

      {/* Gradiente blanco */}

      <Box
        sx={{
          position: "absolute",
          inset: 0,

          background: `
linear-gradient(
90deg,
rgba(255,255,255,1) 0%,
rgba(255,255,255,.98) 25%,
rgba(255,255,255,.94) 48%,
rgba(255,255,255,.82) 70%,
rgba(255,255,255,.96) 100%
)
`,
          zIndex: 2,
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 5,
        }}
      >
        <Box
          component={motion.div}
          initial={{
            opacity: 0,
            y: 35,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: false,
          }}
          transition={{
            duration: 0.8,
          }}
          sx={{
            maxWidth: 560,
          }}
        >
          {/* Icono */}

          <Box
            sx={{
              width: 72,
              height: 72,

              borderRadius: "50%",

              background:
                "rgba(143,21,21,.08)",

              display: "flex",

              alignItems: "center",

              justifyContent: "center",

              mb: 4,
            }}
          >
            <CalendarMonthRoundedIcon
              sx={{
                color: "#8F1515",
                fontSize: 36,
              }}
            />
          </Box>

          {/* Titulo */}

          <Typography
            sx={{
              fontFamily: "Archivo",
              fontWeight: 700,
              
              color: "#13294B",

              lineHeight: 1.05,

              fontSize: {
                xs: "1.8rem",
                sm: "2.4rem",
                md: "3.2rem",
              },
            }}
          >
            Horarios de Clases
          </Typography>

          {/* Línea */}

          <Box
            component={motion.div}
            initial={{
              width: 0,
            }}
            whileInView={{
              width: 90,
            }}
            viewport={{
              once: false,
            }}
            transition={{
              delay: 0.4,
              duration: 0.8,
            }}
            sx={{
              mt: 3,
              mb: 4,

              height: 4,

              background: "#8F1515",

              borderRadius: 20,
            }}
          />

          {/* Texto */}

          <Typography
            sx={{
              color: "#596275",
                fontFamily:'Archivo',
              fontSize: {
                xs: "1rem",
                md: "1.18rem",
              },

              lineHeight: 1.9,
            }}
          >
            Consulta los horarios según el nivel y curso
            correspondiente.
            <br />
            Organización, compromiso y excelencia en
            cada jornada.
          </Typography>
        </Box>
      </Container>

      {/* Decoración */}

      <Box
        sx={{
          position: "absolute",

          right: -120,

          top: -120,

          width: 320,

          height: 320,

          borderRadius: "50%",

          background:
            "radial-gradient(circle,#8F151510 0%,transparent 70%)",

          zIndex: 0,
        }}
      />

      <Box
        sx={{
          position: "absolute",

          left: -100,

          bottom: -120,

          width: 250,

          height: 250,

          borderRadius: "50%",

          background:
            "radial-gradient(circle,#484A7510 0%,transparent 70%)",

          zIndex: 0,
        }}
      />
    </Box>
  );
};